import type { CSSProperties } from 'react';
import styles from './PercentageGauge.module.scss';

/** Keep the displayed percentage and the fill in agreement for invalid CMS values. */
export function normalizePercentage(value: number): number {
  return Number.isFinite(value) ? Math.min(100, Math.max(0, value)) : 0;
}

export default function PercentageGauge({ percentage }: { percentage: number }) {
  return (
    <div
      aria-hidden="true"
      className={styles.gauge}
      style={{ '--gauge-angle': `${normalizePercentage(percentage) * 1.8}deg` } as CSSProperties}
    />
  );
}
